$bog_ui_app_badge $mol_page
	title \Badge
	body /
		<= Description $mol_view
			sub /
				<= description \Compact label component with 5 color variants for status indication.
		<= Variants_title $mol_view
			sub /
				<= variants_title \Variants
		<= Variants $mol_view
			sub /
				<= Default_badge $bog_ui_badge
					label \Default
					type \default
				<= Success_badge $bog_ui_badge
					label \Success
					type \success
				<= Warning_badge $bog_ui_badge
					label \Warning
					type \warning
				<= Error_badge $bog_ui_badge
					label \Error
					type \error
				<= Info_badge $bog_ui_badge
					label \Info
					type \info
